exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttons[data-v-161f7090] {\n  margin-top: 30px;\n}", ""]);

// exports
